import { Loader2 } from 'lucide-react';

export default function LoadingScreen({ label = 'Loading…' }) {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 text-[#AFAFAF]" data-testid="loading-screen">
      <Loader2 size={40} className="animate-spin text-[#1CB0F6]" strokeWidth={3} />
      <span className="font-extrabold">{label}</span>
    </div>
  );
}
